import Styles from "css/landing_css/landing_m.module.css";
import Lheader from "components/landing/l_header_m";
import Lfooter from "components/landing/l_footer_m";
import LogoImg from "assets/landing_assets/l_logo_m_img.png";
import LiosWIcon from "assets/landing_assets/l_ios_w_icon.svg";
import LpsWIcon from "assets/landing_assets/l_ps_w_icon.svg";
import SmartPhoneIcon from "assets/landing_assets/l_smartPhone_m_icon.svg";
import RepairIcon from "assets/landing_assets/l_repair_m_icon.svg";
import CheckIcon from "assets/landing_assets/l_check_m_icon.svg";
import NoteIcon from "assets/landing_assets/l_note_icon.svg";
import ChatIcon from "assets/landing_assets/l_chat_icon.svg";
import PersonIcon from "assets/landing_assets/l_person_icon.svg";
import LiosGIcon from "assets/landing_assets/l_ios_g_icon.svg";
import LpsGIcon from "assets/landing_assets/l_ps_g_icon.svg";
import CarouselPictureM from "../carousel_";
import { Link } from "react-router-dom";

const APP_STORE_URL =
  "https://apps.apple.com/kr/app/%EB%9A%9D%EB%94%B1%EC%9D%B4-%EA%B0%84%ED%8E%B8%ED%95%9C-%EC%88%98%EB%A6%AC%EA%B8%B0%EC%82%AC-%EB%A7%A4%EC%B9%AD/id6743381425";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.ttugttag.ttug&pcampaignid=web_share";

function LandingMainMobile() {
  return (
    <div>
      <Lheader />

      {/* Hero */}
      <section className={Styles.firstContainer}>
        <div className={Styles.firstContent}>
          <div style={{ display: "flex", flexDirection: "column", gap: 16, alignItems: "center" }}>
            <span
              style={{
                display: "inline-flex",
                padding: "5px 12px",
                borderRadius: 9999,
                backgroundColor: "#D1FAE5",
                color: "#047857",
                fontSize: 12,
                fontWeight: 700,
              }}
            >
              농민과 기술자를 잇다
            </span>
            <h1 className={Styles.f30w700black}>
              복잡한 수리 요청
              <br />
              뚝딱이로 한 번에!
            </h1>
            <p className={Styles.f14w400grey}>
              농기계 고장, 더 이상 헤매지 마세요.
              <br />
              뚝딱이는 농가와 수리기사를 실시간으로
              <br />
              연결해주는 매칭 플랫폼입니다.
            </p>
            <div style={{ display: "flex", gap: 10, marginTop: 4, width: "100%", justifyContent: "center" }}>
              <Link to={APP_STORE_URL} className={Styles.appleButton} target="_blank">
                <img src={LiosWIcon} alt="" style={{ width: 16, height: 18 }} />
                <span className={Styles.f16w400white}>App Store</span>
              </Link>
              <Link to={PLAY_STORE_URL} className={Styles.appleButton} target="_blank">
                <img src={LpsWIcon} alt="" style={{ width: 18, height: 20 }} />
                <span className={Styles.f16w400white}>Play Store</span>
              </Link>
            </div>
          </div>
          <img src={LogoImg} alt="뚝딱이 캐릭터" />
        </div>
      </section>

      {/* 이용 방법 */}
      <section className={Styles.secondContainer}>
        <h2 className={Styles.f24w700black}>이용 방법</h2>
        <p className={Styles.f14w400grey} style={{ marginTop: -16 }}>
          간단한 3단계로 빠르게 연결
        </p>
        <div>
          {[
            { icon: SmartPhoneIcon, title: "1. 수리 요청 등록", desc: "농기계 고장 내용을 사진과 함께 앱에 등록하세요" },
            { icon: RepairIcon, title: "2. 수리기사 매칭", desc: "주변의 수리기사에게 실시간으로 요청이 전달됩니다" },
            { icon: CheckIcon, title: "3. 현장 수리 진행", desc: "매칭된 수리기사가 농가에 방문하여 장비를 수리합니다" },
          ].map((step) => (
            <div key={step.title} style={{ textAlign: "center" }}>
              <div className={Styles.greenBall}>
                <img src={step.icon} alt="" />
              </div>
              <div style={{ height: 16 }} />
              <h3 className={Styles.f16w700black}>{step.title}</h3>
              <div style={{ height: 8 }} />
              <p className={Styles.f14w400grey} style={{ padding: "0 12px" }}>
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* 주요 기능 */}
      <section className={Styles.thirdContainer}>
        <h2 className={Styles.f24w700black}>주요 기능</h2>
        {[
          { icon: NoteIcon, title: "수리 요청 시스템", desc: "사진과 고장 내용을 쉽게 등록할 수 있는 간편한 수리 요청 기능을 제공합니다" },
          { icon: ChatIcon, title: "커뮤니티", desc: "농가와 수리기사들이 자유롭게 소통하고 정보를 공유할 수 있는 커뮤니티" },
          { icon: PersonIcon, title: "실시간 기사 매칭", desc: "긴급한 농번기 상황에 가까운 수리기사에게 문의 및 신속하게 매칭 예약이 가능합니다" },
        ].map((feat) => (
          <div key={feat.title} className={Styles.thirdContent}>
            <img src={feat.icon} alt="" />
            <div style={{ height: 12 }} />
            <h3 className={Styles.f16w700black}>{feat.title}</h3>
            <div style={{ height: 8 }} />
            <p className={Styles.f14w400grey}>{feat.desc}</p>
          </div>
        ))}
      </section>

      {/* 앱 스크린샷 */}
      <section className={Styles.fourthContainer}>
        <h2 className={Styles.f24w700black}>앱 스크린샷</h2>
      </section>
      <CarouselPictureM />
      <div style={{ height: 24 }} />

      {/* CTA */}
      <section className={Styles.fifthContainer}>
        <h2 className={Styles.f24w700white}>지금 바로 시작해보세요!</h2>
        <p className={Styles.f14w400white} style={{ padding: "0 16px" }}>
          뚝딱이 앱을 다운로드하고 빠르고 신뢰할 수 있는 수리 서비스를 경험해보세요
        </p>
        <div>
          <Link to={APP_STORE_URL} className={Styles.appleButtonWhite} target="_blank">
            <img src={LiosGIcon} alt="" style={{ width: 18, height: 22 }} />
            <span className={Styles.f16w400green}>App Store에서 다운로드</span>
          </Link>
          <Link to={PLAY_STORE_URL} className={Styles.appleButtonWhite} target="_blank">
            <img src={LpsGIcon} alt="" style={{ width: 22, height: 24 }} />
            <span className={Styles.f16w400green}>플레이스토어 다운로드</span>
          </Link>
        </div>
      </section>

      <Lfooter />
    </div>
  );
}

export default LandingMainMobile;
